import { QC } from "./dt-schema";
import { matchClassification } from "./matchClassification";
import { TandemCategories } from "./TandemCategories";

export class AssetCheck {
    constructor(model, codesWithParam) {
        this.dbId2TandemCategory = model.getData().dbId2TandemCategory;
        this.dbId2Class = model.getData().dbId2Class;
        this.dbId2UfClass = model.getData().dbId2UfClass;

        this.codesWithParam = codesWithParam;

        this.cache = {}
        if(codesWithParam[QC.TandemCategory]) {
            this.cache.tc = new Map();
        }

        if(codesWithParam[QC.Classification] && !this.dbId2Class.isEmpty()) {
            this.cache.dt = new Map();
        }

        if(codesWithParam[QC.UniformatClass] && !this.dbId2UfClass.isEmpty()) {
            this.cache.uf = new Map();
        }
    }

    _matchHierachy(attr, code) {
        return code && this.codesWithParam[attr].some(c => matchClassification(code, c));
    }

    isAsset(dbId) {
        // tandem category
        if(this.cache.tc) {
            const tc = this.dbId2TandemCategory[dbId];
        
            let isAsset = this.cache.tc.get(tc);
            if(isAsset === undefined) {
                const tcCode = TandemCategories.index2code(tc);
                isAsset = this._matchHierachy(QC.TandemCategory, tcCode);
                this.cache.tc.set(tc, isAsset);
            }

            if(isAsset) {
                return true;
            }
        }
        
        // user class
        if(this.cache.dt) {
            const dt = this.dbId2Class.sid2idx[dbId];
            let isAsset = this.cache.dt.get(dt);
            if(isAsset === undefined) {
                const clsCode = this.dbId2Class.get(dt);
                isAsset = this._matchHierachy(QC.Classification, clsCode);
                this.cache.dt.set(dt, isAsset);
            }

            if(isAsset) {
                return true;
            }
        }

        // assmbly code (legacy models)
        if(this.cache.uf) {
            const uf = this.dbId2UfClass.sid2idx[dbId];
            let isAsset = this.cache.uf.get(uf);
            if(isAsset === undefined) {
                const assemblyCode = this.dbId2UfClass.get(uf);
                isAsset = this._matchHierachy(QC.UniformatClass, assemblyCode);
                this.cache.uf.set(uf, isAsset);
            }

            if(isAsset) {
                return true;
            }
        }

        return false;
    }
}